import { ContactsOutlined, FileDoneOutlined } from '@ant-design/icons'
import { useAutoDispatch } from '@api/useAutoDispatch'
import { ReviewHeader } from '@components/OrderDispatch/OptimizerWizard/Results/ReviewHeader'
import { ScheduleGrid } from '@components/OrderDispatch/OptimizerWizard/Results/ScheduleGrid'
import { UnassignedGrid } from '@components/OrderDispatch/OptimizerWizard/Results/UnassignedGrid'
import { Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { Menu, Spin } from 'antd'
import { useState } from 'react'
import type { ReviewResultsProps } from '../types'

export function ReviewResults({ selectedRun, closeWizard, resetOptimizer }: ReviewResultsProps) {
  const [activeTab, setActiveTab] = useState('shiftImpact')

  const menuItems = [
    {
      key: 'shiftImpact',
      label: 'Shift Impact',
      icon: <ContactsOutlined />,
    },
    {
      key: 'unassignedOrders',
      label: 'Unassigned Orders',
      icon: <FileDoneOutlined />,
    },
  ]
  const { useAutoDispatchDetails } = useAutoDispatch()
  const { data, isFetching } = useAutoDispatchDetails(selectedRun?.id)
  if (isFetching)
    return (
      <Horizontal className='full-height-width' verticalCenter horizontalCenter>
        <Spin size='large' />
      </Horizontal>
    )

  return (
    <>
      <ReviewHeader
        data={data}
        closeWizard={closeWizard}
        resetOptimizer={resetOptimizer}
        selectedId={selectedRun?.id}
        createdBy={selectedRun?.created_by}
      />
      <Vertical>
        <Horizontal>
          <Menu
            onClick={(e) => setActiveTab(e.key)}
            selectedKeys={[activeTab]}
            mode='horizontal'
            style={{ flex: 1, minWidth: 0 }}
            items={menuItems}
          />
        </Horizontal>

        {activeTab === 'shiftImpact' && <ScheduleGrid data={data} isFetching={isFetching} />}
        {activeTab === 'unassignedOrders' && (
          <UnassignedGrid loading={isFetching} rowData={data?.unassigned_orders || []} />
        )}
      </Vertical>
    </>
  )
}
